import { Map as MapLibre, type IControl } from "maplibre-gl";

import type { UtdoDate } from "./types";

export class UtdoControl implements IControl {
    private div?: HTMLElement;
    private defaultCenter: [ number, number ];
    private center: [ number, number ];
    private dates: Map<string, UtdoDate>;
    private defaultZoom: number;
    constructor(
        center: [ number, number ],
        dates: Map<string, UtdoDate>,
        defaultZoom: number,
    ) {
        this.center = center;
        this.defaultCenter = center;
        this.dates = dates;
        this.defaultZoom = defaultZoom;
    }
    onAdd(map: MapLibre): HTMLElement {
        this.div = document.createElement("div");
        this.div.classList.add("map-buttons")
        let button = document.createElement("button");
        button.innerText = "Afficher toutes les dates";
        button.addEventListener("click", (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            for (let d of this.dates.values()) {
                if (!d.marker) {
                    continue;
                }
                d.marker.setOpacity("1");
                d.place?.classList.remove("hidden");
            }
            this.center = this.defaultCenter;
            map.setCenter(this.center);
            map.setZoom(this.defaultZoom);
        });
        this.div.append(button);
        button = document.createElement("button");
        button.style.marginTop = "var(--marge)";
        button.innerText = "Centrer la carte";
        button.addEventListener("click", (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            map.setCenter(this.center);
        });
        this.div.append(button);
        return this.div;
    }
    onRemove() {
        this.div?.remove();
    }
    setCenter(center: [ number, number ]): void {
        this.center = center;
    }
}
